import script from "./VTConfidence.vue?vue&type=script&lang=js"
export * from "./VTConfidence.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__